<template>
  <div>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-tabs
      v-model="cdpType"
      color="#f8f8f8"
      :slider-color="$vuetify.theme.primary"
      :style="{ 'max-width': toolListWidth }"
      show-arrows
    >
      <v-tab
        v-for="data in cdpTypeList"
        :key="data.value"
        :style="{ width: 'calc(100% / 2)' }"
        :value="data.value"
        >{{ data.label }}</v-tab
      >
    </v-tabs>
    <div class="pa-3">
      <DrMekCDPProfile v-if="cdpType === 0" :data="pamData" />
      <DrMekCDPLog v-else-if="cdpType === 1" :data="pamData" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DrMekCDPProfile from './DrMekCDPProfile'
import DrMekCDPLog from './DrMekCDPLog'
import doctorMekApi from '@/api/doctor-mek'
import api from '@/api'

export default {
  components: {
    DrMekCDPProfile,
    DrMekCDPLog
  },
  props: {
    userid: {
      value: undefined
    },
    pageid: {
      value: undefined
    }
  },
  data() {
    return {
      user: null,
      loading: false,
      pamData: null,
      toolListWidth: 'auto',
      cdpTypeList: [
        {
          label: 'Info.',
          id: 0
        },
        {
          label: 'Activity Hist.',
          value: 1
        }
      ],
      cdpType: 0 // 0 profile , 1 log
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      try {
        await this.fetchDoctorMekInfo()
      } catch (error) {
        let vm = this
        let data = {
          pageid: vm.selectedBot.pageid,
          userid: vm.userid
        }
        api.getUserOnly(data, function (error, response) {
          if (error) console.error(error)
          vm.user = response.data[0]
          if (vm.user && vm.user.phoneno) {
            vm.fetchDoctorMekInfoByPhoneNo()
          }
        })
      }
    },
    getuserDetail() {},
    async fetchDoctorMekInfo() {
      try {
        if (this.userid) {
          let id = this.userid
          let channel = 'line'
          if (this.userid.startsWith('U') || this.userid.startsWith('LU')) {
            id = this.userid.split('__')[0]
          } else {
            channel = 'facebook'
          }
          let config = {}
          if (channel === 'facebook') {
            config = {
              params: {
                facebook: id
              }
            }
          } else {
            config = {
              params: {
                line: id
              }
            }
          }
          const response = await doctorMekApi.getPamUserInFo(config)
          const userData = response.data
          let formatData = userData
          if (userData && userData.attrs) {
            formatData = {
              ...userData,
              ...userData.attrs
            }
            delete formatData.attrs
          }
          this.pamData = formatData
        }
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async fetchDoctorMekInfoByPhoneNo() {
      try {
        if (this.userid) {
          const config = {
            params: {
              phoneno: this.user.phoneno
            }
          }
          const response = await doctorMekApi.getPamUserInFo(config)
          const userData = response.data
          let formatData = userData
          if (userData && userData.attrs) {
            formatData = {
              ...userData,
              ...userData.attrs
            }
            delete formatData.attrs
          }
          this.pamData = formatData
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/DrMekCDP.vue